export const ES = {

index:{
    title_general: "Simulador de Buceo",
    que_hace_txt: "¿Qué hace?",
    objetivo: "El objetivo no es simular el buceo, es mejorar el buceador real.",
    modelos_txt_1: "Modelos",
    instrumentos_txt: "Instrumentos",
    seguridad_txt: "Seguridad",

    que_se_pierde: "¿Qué se pierde al enseñar buceo sin simulación?",
    teoria_de_perdida: `

        <span style="color:#dfbb73;font-size: 20px;">"La teoría enseña qué hacer. La simulación enseña por qué hacerlo"</span>

        <br><br>Sin simulación, muchos conceptos permanecen abstractos. Los estudiantes memorizan límites, procedimientos y tablas, pero tienen dificultades para visualizar cómo sus decisiones afectan realmente la absorción de gases, la descompresión, la exposición al oxígeno y la seguridad de la inmersión.
        <br><br>La simulación transforma procesos invisibles en experiencias visuales e interactivas. Permite experimentar escenarios, analizar consecuencias y comprender cómo pequeños cambios en profundidad, tiempo o velocidad de ascenso pueden modificar todo un perfil de buceo.
        <br><br>Para los instructores, significa pasar de explicar conceptos a demostrar cómo funcionan en tiempo real.
        <br><strong>Porque el objetivo no es que el alumno recuerde una regla. Es que comprenda las consecuencias de sus decisiones antes de entrar al agua.</strong>`,


        ilustra: `
        El simulador te enseña a actuar correctamente a los errores,
          mostrándote el futuro de tus decisiones antes de que te metas en el agua.
        `,
        preguntas_estrategicas_aprendizaje: `
        Por lo que la pregunta realmente importante es:<br>
          <ul>
            <li>¿Qué ocurriría si tomara una decisión diferente?</li>
            <li>¿Qué sucede si permanezco cinco minutos más en el fondo?</li>
            <li>¿Qué ocurre si asciendo demasiado rápido?</li>
            <li>¿Cómo cambian mis tejidos si utilizo otra mezcla de gases?</li>
            <li>¿Cómo afecta una parada más profunda o más larga a mi perfil de descompresión?</li>
          </ul>
        La simulación permite responder estas preguntas de forma inmediata, visual y segura.`,




    faq_txt: "FAQ",
    login_txt: "Login",

    experiencia_interactiva: "Simulador de buceo | Entrenamiento en seco",
    

    que_hace_2: "<strong>Divantys</strong> te ayuda a entender el buceo antes de entrar al agua. <strong>Reduce riesgo, acelera aprendizaje y mejora decisiones reales bajo presión.</strong>",



    visualiza: "Domina la teoría de buceo. <strong>Aprende a gestionar y optimizar tus buceos</strong> antes de tocar el agua",
    que_hace_4: `
                <strong>El buceo es caro; aprender no tiene por qué serlo.</strong><br>
                Practica en el simulador, no durante una inmersión que estás pagando.<br>
                Entrena en seco, desarrolla experiencia y aprovecha cada minuto de tu aventura bajo el agua.`,



    all_levels: "Para buzos principantes y estudiantes hasta avanzados e instructores ", 
    safety_gestion: "Gestiona y ejecuta paradas de seguridad",
    aire_profundidad: "Extiende tus buceos manejando la profundidad",
    gestion_deco: "Gestiona y ejecuta tus paradas de descompresión",
    ppo2_gestion: "Gestiona y visualiza la PPO2 con la profundidad",


    openModalBtn: "Ver resumen",
    
    relacion_pp: "Anticipar el error es el mejor avance de un buceador",
    ndl: "Límites sin descompresión (NDL)",
    absorcion: "Absorción de nitrógeno (tejidos)",
    exposicion: "Exposición al oxígeno (PPO₂ / CNS)",
    habitos_asenso: "Hábitos de ascenso más seguros",
    consumo_aire: "Consumo de aire y reserva",
    buceo_recreativo: "Buceo recreativo",
    nitrox_compatible: "Nitrox compatible",
    hud: "HUD en pantalla",
    mobil_desktop: "Mobile + Desktop",
    startCta: "Entrar al simulador Gratis",
    que_incluye: "Ver qué incluye",
    tiempo: "Consejo: puedes acelerar el tiempo para observar más rápido la evolución de los indicadores (por ejemplo 2×, 5× o 10×).",
    que_hace_3: "Qué hace este simulador",
    inmersion_virtual: "Divantys Dive Simulator es una plataforma interactiva de simulación y aprendizaje del buceo que permite visualizar de forma gráfica y en tiempo real los procesos físicos y fisiológicos que ocurren durante una inmersión. Su objetivo es transformar conceptos complejos de la teoría del buceo, la descompresión y la fisiología humana en una experiencia visual fácil de entender para buceadores, estudiantes, instructores y profesionales de la industria. Divantys funciona como un laboratorio virtual donde puedes explorar cómo responde el cuerpo humano a diferentes perfiles de inmersión, mezclas de gases, profundidades y tiempos de exposición.",
    experiencia_3d: "Experiencia 3D controlable",
    movimiento_cacara: "Movimiento y cámara con controles adaptados a móvil, tablet y PC.",
    joistick_movimiento: "Joystick de movimiento",
    joistick_rotacion: "Joystick de mirada/rotación",
    neutral_flotabilidad: "Zona neutral para estabilidad",
    indicadores_hud: "Indicadores en HUD",
    instrumentos_visuales: "Instrumentos visuales en pantalla para comprensión inmediata.",
    tanque: "Tanque: bar / PSI / porcentaje",
    barra_nitrogeno: "Barra de nitrógeno (educativa)",
    ndl_estado: "NDL y estado de ascenso",
    reporte: "Reporte completo",
    resumen: "Resumen de la inmersión para aprendizaje y análisis.",
    profundidad_maxima: "Profundidad máxima",
    tiempo_total: "Tiempo total",
    ndl_total: "NDL total y restante",
    ceiling: "Ceiling (profundidad mínima segura)",
    modelos_txt: "Modelos y conceptos representados",
    simulador_implementa: "El simulador implementa modelos fisiológicos y reglas educativas habituales en el buceo recreativo: absorción y liberación de nitrógeno por tejidos, límites sin descompresión, y exposición al oxígeno.",
    modelo_tejidos: "Modelo de tejidos (16 compartimentos)",
    simulador_carge_nitrogeno: "Simula la carga de nitrógeno en distintos tejidos con velocidades diferentes, permitiendo estimar saturación, “ceiling” y el comportamiento en inmersiones repetitivas.",
    expoosicion_o2: "Exposición al oxígeno (PPO₂ / CNS)",
    calculo_po2: "Calcula PPO₂ según profundidad y fracción de oxígeno (FO₂), y acumula exposición CNS con un modelo de límites por PPO₂.Incluye niveles de alerta (OK / WARNING / DANGER).",
    ndl2: "NDL (No Decompression Limit)",
    caluclo_ndl: "Calcula un NDL “recreativo” basado en profundidad y tiempo, con soporte para Nitrox (EAD).",
    ndl_total_permitido: "NDL total permitido",
    ndl_restante: "NDL restante según el perfil",
    interpretacion_riesgos: "Interpretación educativa del riesgo",
    ceiling_asecenso: "Ceiling y ascenso",
    estimacion_profundidad_ceiling: "Estima una profundidad mínima segura (ceiling) y evalúa si el ascenso puede hacerse sin paradas.",
    ceiling_metros: "Ceiling en metros",
    deteccion_parada: "Detección de “stop requerido”",
    recomendacion_parada: "Recomendación de parada de seguridad",
    inmersiones_repetitivas: "Inmersiones repetitivas",
    carga_residual: "Mantiene carga residual entre inmersiones y simula intervalos en superficie.",
    tejidos_conservan: "Tejidos se conservan entre inmersiones",
    intervalo_superficie: "Intervalo en superficie reduce carga",
    aprendizaje_acumulacion: "Aprendizaje de acumulación residual",
    instrumentos_visualizacion_hud: "Instrumentos y visualización (HUD)",
    facilitar_comprension: "Para facilitar la comprensión, el simulador muestra instrumentos visuales en pantalla durante la inmersión. Su propósito es que el usuario “vea” cómo cambian los conceptos con su comportamiento.",
    tanque_aire: "Tanque de aire (AL80)",
    simula_consumo_sac: "Simula consumo según SAC, presión ambiente y tiempo simulado.",
    presion_bar_psi: "Presión en bar y PSI",
    gas_restante: "Porcentaje restante",
    alerta_reserva: "Alerta de reserva (ej. 35 bar)",
    sin_aire: "Estado “sin aire” (out of air)",
    barra_nitrogeno_2: "Barra de nitrógeno",
    visualizacion_educativa: "Visualización educativa del aumento/disminución de carga.",
    suavisado_visual: "Suavizado visual (carga lenta / descarga normal)",
    colores_nivel: "Colores por nivel (verde→rojo)",
    enfoque_didactico: "Enfoque didáctico, fácil de interpretar",
    ndk_y_estado_ascenso: "NDL y estado del ascenso",
    indicadores_limites_descompresion: "Indicadores para comprender límites sin descompresión y hábitos de ascenso.",
    ndl_restante_2: "NDL restante",
    recomendacion_parada_2: "Recomendación de parada de seguridad",
    ceiling_si_aplica: "Ceiling (si aplica)",
    escala_tiempo_safety_stop: "Escala de tiempo (1×, 2×, 5×, 10×)",
    acelerar_tiempo: "Puedes acelerar la simulación para observar más rápido cómo cambian los valores. Esta función es útil para educación: muestra la tendencia de los indicadores sin tener que esperar largos periodos.",
    safety_stop_title: "Safety Stop (Parada de seguridad recreativa)",
    safety_stop_resumen: "Este módulo simula la parada de seguridad a 5 metros en buceo recreativo. Su lógica está basada en control de tiempo real escalado, tolerancia de profundidad y detección de interrupciones o redescensos para validar o invalidar la parada.",
    deteccion_recomendacion: "Recomendación de parada",
    safety_recommendation_meta: "La parada se recomienda automáticamente según el perfil de inmersión.",
    profundidad_maxima_safety_stop: "Se activa si la profundidad máxima supera 10 m",
    exclusion_descompresion: "Se desactiva si existe deco activa o requerida",
    estado_recomendado: "Estado: recommended → activa el safety stop",
    callback_recomendacion: "Callback opcional de notificación al usuario",
    logica_ejecucion: "Lógica de ejecución",
    safety_execution_meta: "El sistema controla el tiempo en la zona de 5 metros con tolerancia y escalado temporal.",
    zona_parada: "Zona de parada: 5 m ± 2 m",
    zona_pausa: "Zona de pausa: 5 m - 3 m (sin progreso)",
    acumulacion_tiempo_safety_stop: "Acumulación de tiempo en segundos simulados",
    escala_tiempo: "Escalado por velocidad de simulación (GET_TIME_SCALE)",
    completado_3min: "Completado tras 180 segundos efectivos",
    pausa_reanuda: "Pausa automática al salir de la zona",
    interrupciones_redescenso: "Interrupciones y redescenso",
    safety_interrupt_meta: "Detecta si el buceador abandona la parada o vuelve a profundidad tras completarla.",
    rompe_parada: "Salida de zona invalida la progresión",
    cancelacion: "Estado cancelled activa reinicio de seguimiento",
    interrupted_flag: "Marca interrupción si se rompe la lógica",
    redescenso_invalida: "Redescenso &gt; 6 m reanuda recomendación",
    ventana_tiempo: "Ventana de 30 s para invalidación post-completado",
    safety_stop_tiempo: "Control de tiempo en parada",
    safety_stop_explicacion: "El tiempo se calcula en tiempo real simulado, acumulando solo cuando el buceador permanece dentro del rango correcto. Si abandona la zona, el contador se pausa. Si completa los 3 minutos efectivos, la parada se marca como completada. Sin embargo, un redescenso posterior puede invalidarla bajo ciertas condiciones fisiológicas.",
    nitrogen_load_title: "Barra de carga de nitrógeno (UI educativa)",
    nitrogen_load_resumen: "Este módulo visualiza en tiempo real la carga de nitrógeno en los tejidos rápidos del buceador. Su objetivo es educativo: mostrar cómo evoluciona la saturación relativa durante la inmersión mediante una barra de progreso suavizada y codificada por colores.",
    visualizacion_n2: "Visualización de la carga de N₂",
    n2_visual_meta: "Representa de forma simplificada el nivel de saturación de nitrógeno en tejidos rápidos.",


    ppo2_vizualiza:"PPO₂ y CNS",
    ppo2_visualiza_desc:"Visualiza la toxicidad por oxígeno usando PPO₂ y CNS acumulado. El estado se representa mediante niveles de riesgo fisiológico.",
    ppo2_visualiza_p1:"Nivel de toxicidad colores ilustrativos",
    ppo2_visualiza_p2:"CNS Acumulado",

    profundimetro:"Profundidad en tiempo real",
    profundimetro_educativa: "Monitorización continua de la profundidad para comprender mejor la evolución del perfil de inmersión.",
    profundimetro_visualiza_p1: "Actualización dinámica de profundidad durante toda la inmersión.",
    profundimetro_visualiza_p2: "Suavizado visual que simula el comportamiento de instrumentos reales.",



    tejidos_rapidos: "Basado en tejidos rápidos del modelo fisiológico",
    valor_porcentual: "Valor expresado en porcentaje (0–130%)",
    suavizado_visual_2: "Suavizado visual para evitar saltos bruscos",
    actualizacion_tiempo_real: "Actualización en tiempo real",
    codigo_colores_n2: "Código de colores",
    n2_colors_meta: "La barra cambia de color según el nivel de carga para facilitar la interpretación rápida.",
    verde_seguro: "Verde: carga baja y estable (&lt; 60%)",
    amarillo_atencion: "Amarillo: zona de atención (60%–85%)",
    naranja_alto: "Naranja: carga alta (85%–100%)",
    rojo_riesgo: "Rojo: sobresaturación potencial (&gt; 100%)",
    logica_suavizado: "Lógica de suavizado y estabilidad",
    n2_smoothing_meta: "El valor visual no cambia instantáneamente, sino que se aproxima progresivamente al valor real.",
    interpolacion_visual: "Interpolación progresiva (ease-in / ease-out)",
    respuesta_diferencial: "Respuesta más lenta al aumento que a la disminución",
    prevencion_flicker: "Prevención de flickering visual",
    clamp_visual: "Clamp de valores entre 0% y 130%",
    n2_bar_texto_secundario: "Información secundaria (GF / estado fisiológico)",
    n2_bar_explicacion: "La barra puede incluir texto adicional (como Gradient Factor o estado fisiológico del modelo). Esto permite correlacionar visualmente la saturación de nitrógeno con el estado de descompresión, ofreciendo una representación más intuitiva del riesgo acumulado.",
    air_consumption_title: "Consumo de aire (AL80 multi-tanque)",
    air_consumption_resumen: "Este módulo simula el consumo real de gas en tiempo dinámico utilizando SAC (Surface Air Consumption), presión ambiente y escala de tiempo. Soporta configuraciones de uno o múltiples tanques y calcula el agotamiento progresivo del sistema completo.",
    modelo_consumo: "Modelo de consumo",
    air_model_meta: "El consumo se basa en el SAC del buceador ajustado por la presión ambiente y el tiempo simulado.",
    sac_rate: "SAC configurable por usuario",
    presion_ambiente: "Presión ambiente = 1 + profundidad/10",
    escala_tiempo_aire: "Escalado por GET_TIME_SCALE()",
    consumo_proporcional: "Consumo proporcional por tanque",
    sistema_multitanque: "Sistema multi-tanque",
    air_tanks_meta: "El sistema distribuye el consumo entre todos los tanques activos del equipo.",
    al80_base: "Tanque base AL80 (2265 L)",
    multi_tank_support: "Soporte para múltiples tanques",
    division_consumo: "Consumo dividido entre tanques activos",
    estado_out_of_air: "Estado global OUT OF AIR",
    visualizacion_hud_aire: "Visualización HUD",
    air_hud_meta: "Cada tanque se representa con una barra vertical de nivel y lectura de presión en bar y PSI.",
    nivel_visual_barra: "Nivel visual por porcentaje de volumen",
    bar_psi_conversion: "Conversión bar / PSI en tiempo real",
    colores_reserva: "Color según reserva (verde → naranja → rojo)",
    alerta_reserva_aire: "Alerta por debajo de 35 bar",
    air_system_tank_title: "Estado del sistema de aire",
    air_system_explainer: "El sistema calcula el volumen total restante sumando todos los tanques activos. El consumo se actualiza en cada frame simulado y permite detectar el punto de reserva o la condición crítica de “sin aire”. El modelo refleja tanto consumo individual como global.",
    oxygen_toxicity_title: "Toxicidad por oxígeno (NOAA CNS)",
    oxygen_toxicity_resumen: "Este módulo evalúa el riesgo de toxicidad por oxígeno usando PPO₂ y CNS acumulado. El estado se representa mediante niveles de riesgo fisiológico tipo ordenador de buceo.",
    ppo2_model: "Presión parcial de oxígeno (PPO₂)",
    ppo2_meta: "Determina el riesgo inmediato de toxicidad aguda.",
    formula_ppo2: "PPO₂ = FO₂ × presión ambiente",
    limite_ppo2: "Límite operativo: 1.4 bar",
    limite_critico: "Crítico: ≥ 1.6 bar",
    cns_model: "CNS (Sistema nervioso central)",
    cns_meta: "Acumulación progresiva de exposición al oxígeno según modelo NOAA.",
    noaa_model: "Modelo NOAA de exposición",
    acumulacion_cns: "Incremento progresivo por tiempo",
    limite_cns: "100% = límite recomendado",
    estado_oxigeno: "Estado de toxicidad",
    oxy_state_meta: "Evaluación combinada de PPO₂ y CNS en tiempo real.",
    stateOK: "OK",
    stateWARN: "WARNING",
    stateDANGER: "DANGER",
    state_ok: "OK: exposición dentro de límites seguros",
    state_warning: "WARNING: zona de precaución",
    state_danger: "DANGER: riesgo de toxicidad aguda",
    oxygen_system_title: "Modelo de riesgo de oxígeno",
    oxygen_system_explainer: "El sistema combina toxicidad aguda (PPO₂) y toxicidad acumulativa (CNS). El estado mostrado refleja el nivel de riesgo dominante en cada momento de la inmersión, similar a un ordenador de buceo técnico real.",
    logica_deco_engine: "Lógica del motor de descompresión (Bühlmann + GF)",
    resumen_logica_deco: "Este módulo calcula en tiempo real el plan de descompresión del buceador simulando la saturación de tejidos con nitrógeno, generando paradas obligatorias y ajustando el perfil de ascenso según el estado fisiológico y el gradiente de seguridad (GF). Además, mantiene un historial persistente para no perder progreso entre regeneraciones del plan.",
    generacion_plan: "Generación del plan de descompresión",
    plan_buhlmann: "El sistema construye un perfil de paradas basado en el modelo Bühlmann con Gradient Factors.",
    calculo_ceiling: "Cálculo del ceiling con GF line (límite de ascenso seguro)",
    redondeo_paradas: "Redondeo a escalones de parada (STOP_STEP_M)",
    simulacion_exposicion: "Simulación de carga de tejidos por parada",
    condicion_fin: "Finaliza cuando el ceiling baja de 3 m (STOP_REQUIRED_M)",
    modo_preview: "Modo preview sin afectar historial real",
    historial_persistencia: "Historial y persistencia de paradas",
    deco_history: "El sistema guarda el progreso de cada parada para evitar pérdidas de estado durante regeneraciones.",
    decohistory_array: "decoHistory almacena progreso por profundidad",
    hydrate_paradas: "Hydratación de paradas desde historial",
    preserva_progreso: "Preserva tiempo realizado (timePerformedSec)",
    evita_reset: "Evita reinicios de paradas ya iniciadas",
    merge_plan: "Fusión entre plan nuevo y estado previo",
    update_deco_logic: "El motor recalcula continuamente el estado de descompresión según profundidad, tiempo simulado y tejidos.",
    control_parada_actual: "Control de parada actual con tolerancia de profundidad",
    bloqueo_orden: "Bloqueo de orden (no saltar paradas anteriores)",
    regeneracion_dinamica: "Regeneración si el perfil empeora o mejora",
    acumulacion_tiempo: "Acumulación de tiempo por dtSimSec",
    auto_complete: "Auto-completado al 95% de cumplimiento",
    tts_dinamico: "Cálculo dinámico del TTS (ascenso + paradas)",
    tts_resumen: "Tiempo total de ascenso (TTS)",
    tts_explicacion: "El TTS se calcula combinando el tiempo de ascenso tramo a tramo (según velocidad de subida) más el tiempo restante en paradas de descompresión activas. El resultado se ajusta continuamente en función del estado real de los tejidos y del plan vigente.",
    uso_responsable: "Uso responsable y aviso importante",
    herramienta_educativa: "Este proyecto es una herramienta educativa e ilustrativa. El buceo real requiere formación, equipo certificado y supervisión profesional.",
    importante: "Importante",
    que_hace_3_txt: "Este simulador <strong>no</strong> es un curso de buceo, <strong>no</strong> reemplaza formación formal, y <strong>no</strong> es una computadora de buceo ni una herramienta operativa de planificación. <strong>No</strong> debe utilizarse para planificar inmersiones reales ni para la toma de decisiones. Todo lo mostrado es <strong>únicamente ilustrativo</strong>, usando conceptos y algoritmos aplicados solo con fines de simulación y visualización. El uso del simulador es responsabilidad del usuario.",
    ackCheck: "",
    entiendo_educativo: "Entiendo que este simulador es solo educativo, no reemplaza entrenamiento certificado ni una computadora de buceo, y no debe usarse para planificar ni realizar inmersiones reales.",
    enterBtn: "Entrar al simulador",
    learnMoreBtn: "Ver detalles del sistema",
    faq_txt_2: "Preguntas frecuentes",
    que_es: "¿Esto es un planificador de buceo?",
    es_aprendizaje_visual: "No. Es una herramienta de aprendizaje visual. No debe usarse para planificar inmersiones reales.",
    que_gases_contempla: "¿Qué gases contempla?",
    cuales_gases: "Se contempla aire y Nitrox mediante fracción de oxígeno (FO₂), afectando NDL, nitrógeno y PPO₂/CNS.",
    mobil_funciona: "¿Funciona en móvil?",
    si_funciona_mobil: "Sí. Los controles se adaptan con joysticks y manejo por eventos de puntero (pointer events).",

    se_descarga: "¿Se tiene que descargar?",
    no_se_descarga: "Usamos tecnología <strong>3D WebGL</strong> para que no tengas que descargarla de ninguna tienda de aplicaciones y tengas uso libre e ilimitado directo en tu navegador",

    team_txt_2: "Equipo",
    gonzalo_desc: "Instructor de Buceo | Técnico en Software",
    title_footer: "Simulador de Buceo",
    footer_experiencia: "Experiencia educativa e ilustrativa",
    consejo_ambiental: "Consejo ambiental: mantener flotabilidad y movimiento consciente protege el arrecife y la vida marina.",
    modalTitle: "Resumen del sistema",
    closeModalBtn: "Cerrar",
    actualiza_indicadores: "El simulador actualiza indicadores de seguridad y fisiología durante la inmersión virtual y genera un reporte de salida para aprendizaje.",
    fisiologia: "Fisiología (tejidos)",
    compartimentos_2: "16 compartimentos simulados, carga de nitrógeno y estimación de ceiling/ascenso.",
    ndl_nitros: "NDL y Nitrox",
    ndl_recreativo: "NDL recreativo, soporte de FO₂ con equivalente de profundidad (EAD) a nivel educativo.",
    consumo_aire_2: "Consumo de aire",
    consumo_basado_sac: "Consumo basado en SAC, presión ambiente y tiempo simulado; alertas de reserva y sin aire.",
    oxigeno_cns: "Oxígeno (PPO₂ / CNS)",
    calculo_ppo2: "Calcula PPO₂ por profundidad y FO₂; acumula exposición CNS y muestra alertas.",
    fines_educativos: "Nota: todos los valores y visualizaciones son para fines educativos y de simulación.",
    closeSlideBtn: "❌",

    safety_stop_menu:"Parada Seguridad",
    nitrogen_bar_menu:"N₂ Barra",
    consumo_aire_menu:"Consumo de Gas",
    oxicidad_oxigeno_menu:"O2 Toxicidad",
    deco_menu: "DECO",
    deco_y_paradas_deco: "DECO y Sus respectivas de descompresión",


    registro_existoso: "¡Registro Completado!",
    instrucciones_email_registro: "Tu cuenta ha sido creada con éxito. Valida Tu cuenta en tu correo electrónico para ingresar! Gracias",
    cintinuar: "Continuar",




},


payment_stripe:{

  title:"Pago seguro con Stripe",
  ammount_txt:"Total a pagar:<br>",
  currency:"Euros",
  pagar_ahora:"Pagar Ahora",
  continuar:"Continuar",
  cancelar:"Cancelar",
  error: "Error",
  completa_inputs:"Please complete all fields",
  close:"Close",
  error_passwords:"Passwords Error",
  passwords_no_iguales:"Passwords not match",
  error_email: "Error Email",
  ingresa_email_valido:"Please enter a valid email address.",
  user_data:"Datos de Usuario",
  create_account:"Crea una cuenta nueva",
  pago_exitoso:"Pago realizado",
  pago_compeltado:"Tu pago ha sido completado con éxito",
  pago_proceso:"Pago en proceso de acreditación",
  confirmaremos_pago:"Estaremos pendientes de confirmar tu pago",
  pago_fallido:"Error al realizar el pago",
  fallo_autenticacion_declinado:"Fallo de autenticación o declinado",
  status_pago:"Estatus de pago",
  cuenta_existente:"Esta cuenta ya existia",
  cuenta_existente_txt:"Este email ya había sido registrado con anterioridad"

},



login:{

  iniciar_session: "Iniciar sesión",
  accede_a_cuenta:"Accede a tu cuenta",
  email:"Email",
  password:"Password",
  iniciar_session_btn:"Iniciar sesión ahora",
  verificando:"Verificando.....",
  credenciales_incorrectas:"Credenciales incorrectas"


},



stripe_user_data:{
  user_data:"Datos de usuario",
  create_account:"Crea una cuenta nueva",
  username:"Nombre de usuario",
  enter_username:"Ingresa el nombre completo",
  email_user:"Email de usuario",
  enter_email:"Ingresa un email",
  password:"Password",
  enter_password:"Ingresa un password",
  repeat_password:"Repetir password",
  enter_repeat_password:"Ingresa el mismo password",
  seleccion_suscripcion:"Selecciona tipo de suscripción",
  mensual:"Mensual",
  semestral:"Semestral",
  anual:"Anual"
},




cookies:{

  title:"Cookies Requeridas",
  message:"Esta web requiere de cookies para funcionar adecuadamente. Debes aceptar su uso para poder continuar",
  reject:"Declinar",
  accept:"Aceptar",
  acceso_denegado:"Acceso denegado",
  debes_aceptar:"Se requiere la autorizacion de cookies para continuar"

},



condiciones:{

  full:  ` 


<div id="legal_conditions" class="legal_conditions">

<div class="legal_header">
<h1>Términos y Condiciones de Uso</h1>
</div>


<div id="legal_scroll_container" class="legal_scroll_container">


<div class="section_legal">

<h2>1. IDENTIFICACIÓN DEL RESPONSABLE</h2>

<p>
En cumplimiento de la Ley 34/2002 de Servicios de la Sociedad de la Información (LSSI-CE),
se informa que el presente sitio web es titularidad de:
</p>

<ul>
<li><strong>DIVANTIS</strong></li>
<li><strong>Email de contacto:</strong> admin@divantys.com</li>
<li><strong>Domicilio fiscal:</strong> Málaga, España</li>
<li><strong>Actividad:</strong> prestación de servicios digitales remotos</li>
</ul>

</div>


<div class="section_legal">

<h2>2. OBJETO Y CONDICIONES DE USO</h2>

<p>
El presente sitio web ofrece servicios digitales, contenidos interactivos
y herramientas online. El acceso al sitio implica la aceptación
de las presentes condiciones.
</p>

<p>El usuario se compromete a:</p>

<ul>
<li>No realizar actividades ilícitas</li>
<li>No introducir código malicioso</li>
<li>No intentar acceder a sistemas restringidos</li>
<li>No utilizar el sitio con fines fraudulentos</li>
</ul>

</div>


<div class="section_legal">

<h2>3. PROPIEDAD INTELECTUAL</h2>

<p>
Todos los contenidos del sitio (textos, código, diseño, software e imágenes)
son propiedad del titular o cuentan con licencia.
Queda prohibida su reproducción sin autorización expresa.
</p>

</div>


<div class="section_legal">

<h2>4. EXCLUSIÓN DE RESPONSABILIDAD</h2>

<p>
El sitio se proporciona "tal cual". El titular no garantiza
disponibilidad continua ni ausencia de errores técnicos.
</p>

</div>


<div class="section_legal">

<h2>5. POLÍTICA DE PRIVACIDAD (RGPD)</h2>

<h3>Datos recopilados</h3>

<ul>
<li>Nombre</li>
<li>Correo electrónico</li>
<li>Datos enviados mediante formularios</li>
<li>Datos técnicos de navegación</li>
</ul>

<h3>Finalidad</h3>

<ul>
<li>Responder consultas</li>
<li>Enviar información solicitada</li>
<li>Mejorar el servicio</li>
<li>Comunicaciones comerciales (con consentimiento)</li>
</ul>

</div>


<div class="section_legal">

<h2>6. TRANSFERENCIAS INTERNACIONALES</h2>

<p>
En caso de utilizar proveedores tecnológicos ubicados fuera del
Espacio Económico Europeo, se aplicarán las cláusulas contractuales
estándar aprobadas por la Comisión Europea.
</p>

</div>


<div class="section_legal">

<h2>7. POLÍTICA DE COOKIES</h2>

<p>
El sitio puede utilizar cookies técnicas y analíticas
para mejorar la experiencia del usuario.
</p>

</div>


<div class="section_legal">

<h2>8. MODIFICACIONES</h2>

<p>
El titular podrá modificar estas políticas en cualquier momento.
Las modificaciones entrarán en vigor desde su publicación.
</p>

</div>


<div class="section_legal">

<h2>9. LEGISLACIÓN Y JURISDICCIÓN</h2>

<p>
Las presentes condiciones se rigen por la legislación española.
Las partes se someten a los tribunales de Málaga, España.
</p>

</div>


<div class="section_legal">

<h2>10. CONTACTO</h2>

<p>
Para cualquier consulta relacionada con estas políticas:
</p>

<p>
📧 admin@divantys.com
</p>

</div>


</div>



<div class="legal_controls">

<button id="legal_continue_btn">
Aceptar y continuar
</button>

</div>

</div>

    ` 

},


 // ===================================================
  // GENERALES
  // ===================================================
  general: {
    ok: "OK",
    cancel: "Cancelar",
    salir: "Salir",
    button_fisiologia: "Fisiología del buceo",
    closeReset: "Cerrar y reiniciar",
    startDive: "Iniciar inmersión",
    startNextDive: "Iniciar siguiente inmersión",
    firstDive: "Primera inmersión",
    repetitiveDive: "Inmersión repetitiva",
    Dive: "Inmersion #",
    reduce_ascent_speed: "Reducir la velocidad de ascenso disminuye la sobrecarga de nitrógeno.",
    controlled_ascent_text: "Recuerda que tus ascensos deben ser lentos y controlados para evitar la saturación de los tejidos. Usa la “Carga de Nitrógeno” como referencia"
  },

  // ===================================================
  // ALERTAS / MENSAJES
  // ===================================================
  alerts: {
    notice: "Aviso",
    invalidSurface: "Intervalo en superficie inválido",
    noRepetitive: "No se permiten inmersiones repetitivas después de esta inmersión",
    noTissueData: "No hay datos tisulares disponibles",
    recalculating: "Recalculando compartimentos tisulares…",

          outOfAir: {
          title: "🚨 Sin aire",
          button: "Entiendo",
          html: `
            <strong>Situación crítica detectada.</strong><br><br>

            • Suministro de gas agotado<br>
            • Inicie un ascenso controlado de inmediato<br>
            • Exhalación continua (CESA)<br>
            • Mantenga una velocidad de ascenso segura<br><br>

            <em>Esta inmersión ha sido finalizada por razones de seguridad.</em>
          `
        },
        modExceeded: {
            icon: "🫁⚠️",
            color: "#c62828",
            title: "🚨 MOD excedido para EAN{{ean}}",
            button: "Entiendo",
            html: `
              <strong>Está más profundo que la profundidad operativa segura para este gas.</strong><br><br>

              <strong>Detalles:</strong><br>
              • Profundidad actual: <strong>{{depth}} m</strong><br>
              • MOD (PPO₂ 1.4): <strong>{{mod}} m</strong><br>
              • Acción: <strong>ascienda</strong> inmediatamente a menor profundidad<br><br>

              <em>Esta inmersión ha sido finalizada por razones de seguridad.</em>
            `
          },
          recreationalLimitExceeded: {
            icon: "🚫",
            color: "#c62828",
            title: "🚨 Límites recreativos excedidos",
            button: "Entiendo",
            html: `
              <strong>Ha descendido más allá de los límites estándar del buceo recreativo.</strong><br><br>

              <strong>Esto significa:</strong><br>
              • No aplica un NDL recreativo<br>
              • Es probable que se requiera descompresión<br>
              • Se requiere entrenamiento técnico<br>
              • Puede ser necesaria planificación de gas y ascensos escalonados<br><br>

              <em>Esta inmersión ha sido finalizada por razones de seguridad.</em>
            `
          },
           ndlExceeded: {
              icon: "⏱",
              color: "#c62828",
              title: "🚨 Límite sin descompresión excedido",
              button: "Entiendo",
              html: `
                <strong>Ha excedido el límite sin descompresión.</strong><br><br>

                <strong>Acción requerida:</strong><br>
                • Ascienda inmediatamente de forma lenta y controlada<br>
                • Velocidad máxima de ascenso: <strong>9–10 m/min</strong><br>
                • Realice una parada de seguridad a <strong>5 m durante 3–5 minutos</strong><br><br>

                <em>Esta inmersión ha sido finalizada por razones de seguridad.</em>
              `
            },
            safetyStopInterrupted: {
                title: "Parada de seguridad interrumpida",
                text:  "Desciende a 5 metros para reiniciar la parada de seguridad.",
                color: "warning"
              },
              safetyStopCompleted: {
                title: "Parada de seguridad completada",
                text: "Puedes continuar el ascenso de forma segura.",
                color: "success"
              },
              low_air_reserve_reached: {
                title: "Aire bajo — Reserva",
                text:
                `Tu reserva de aire es de: (≈35 bar).

                • Inicia ascenso lento y controlado
                • No más de 9–10 m/min
                • Prepara tu parada de seguridad a 5m
                • Mantén la calma y respira lentamente`,
                color: "warning"
              }



  },

  // ===================================================
  // LOGS / ESTADOS (visibles o futuros)
  // ===================================================
  logs: {
    decoRequired: "🚨 Se requería descompresión (criterio recreativo)",
    nearNDL: "⚠️ Cerca del límite sin descompresión",
    highTissue: "🟠 Alta carga tisular (modelo fisiológico)",
    withinLimits: "✅ Inmersión dentro de límites recreativos"
  },

  // ===================================================
  // ESTADO DE LA INMERSIÓN
  // ===================================================
  diveStatus: {
    completed: "✅ Inmersión completada",
    failedDeco: "🚨 Inmersión fallida — Se requería descompresión",
    highTissue: "⚠️ Inmersión completada — Alta carga tisular",
    nearNDL: "⚠️ Inmersión completada — Cerca del límite sin descompresión",
    dangerous_ascent: "🚨 En algún momento tuviste un ascenso descontrolado. Ten cuidado",
    fast_ascent: "⚠️ En algún momento ascendiste más rápido de lo permitido (9 m/min). Siempre controla tus ascensos y anticipa cambios de profundidad"
  },

  // ===================================================
  // SAFETY STOP
  // ===================================================
  safetyStop: {
    title: "Parada de seguridad",
    completed: "✅ <strong>Parada de seguridad completada</strong>",
    notCompleted: "⚠️ <strong>Parada de seguridad no completada</strong>",
    timeAt5m: "Tiempo a 5 m",
    completedAfterInterruptions: "Completada con interrupciones",
    back_5m :"⬆️ Regresa a 5 m",
    hold_5m :"⏸ Mantente en los 5 m",
    target_depth: "Prof. objetivo: 5 m"

  },



   nitrogen_bar: {
    title: "Carga de N₂ (tejidos rápidos)",

  },

  // ===================================================
  // REPORTE / RESUMEN
  // ===================================================
  report: {
    diveNumber: "Inmersión",
    time: "Tiempo",
    maxDepth: "Prof. máx",
    gas: "Gas",
    tank: "Tanque",
    startPressure: "Presión inicial",
    endPressure: "Presión final",
    airUsed: "Aire usado",
    sac: "SAC",
    reserveReached: "Reserva alcanzada",
    ceiling: "Techo",
    gf: "GF",
    tissueTitle: "Compartimentos tisulares",
    tissueNote:"Los compartimentos en rojo indican tejidos limitantes — no descompresión obligatoria.",
    ceiling :"Ceiling",
    safetystop: "Parada Seguridad",
    analisis_avanzado: "Analisis Avanzado",
    oxigen_tox: "Toxisidad O2",
    gradient_factor: "Factor Gradiente",
    tejido_lider: "Tejido Líder",
    comparimento_tiempo_medio : "Comp. Tiempo medio",
    tension_tejido: "Tensión del tejido",
    tension_max_permitida: "Tensión Máxima Permitida",
    load_perfil: "Carga del Perfil"
  },



  camera_hud: {
    t1: "Ajustar Balance Neutral",
    level_ok: "✓ Neutral",
    level_hint: "Toca ⦿ para nivel neutral"
  },

  // ===================================================
  // PERFIL
  // ===================================================
  profile: {
    title: "Perfil de profundidad"
  },

  // ===================================================
  // COMPARTIMENTOS / TISSUES
  // ===================================================
  tissues: {
    title: "Compartimentos tisulares (N₂)",
    surfaceOffGassing: "Descarga en superficie",
    afterInterval: "Después de",
    minutes: "min",
    offGas: "⬇ liberación",
    onGas: "⬆ absorción",
    tissues_data_invalidos: "No Informacion de comparimentos"
  },

  // ===================================================
  // INTERVALO DE SUPERFICIE
  // ===================================================
  surface: {
    title: "Escala de Tiempo de la Simulación",
    invalid_interval_surface: "Tiempo de intervalo invalido",
    recalc: "Recalcular tejidos",
    after: "Después de",
    notAllowed: "No se permiten inmersiones repetitivas tras esta inmersión"
  },




   scale_time_home: {
    title: "Escala de Tiempo de la Simulación",
      text: `
        Este simulador puede <strong>acelerar el tiempo</strong> para facilitar
        la visualización de procesos fisiológicos (NDL, carga de nitrógeno,
        comportamiento de ascenso) que en el buceo real toman mucho más tiempo.
        <br><br>
        Esto <strong>no</strong> representa tiempo real y se utiliza
        <strong>solo con fines educativos y visuales</strong>.
      `,
      real_time: "Real",
      choose: "Selecciona la velocidad de simulación:",
      start: "Iniciar inmersión"
  },




  // ===================================================
  // REPETITIVAS
  // ===================================================
  repetitive: {
    tag: "Inmersión repetitiva",
    info:
      "Esta inmersión comienza con nitrógeno residual de una inmersión previa. Se recomienda un ascenso conservador y una parada de seguridad completa.",
    first_dive: "Primera Inmersión",
    repetitive_dive: "Inmersión repetitiva", 
  },

  // ===================================================
  // EDUCACIÓN / AVISO LEGAL (HTML LARGO)
  // ===================================================
  education: {
    longHTML: `
<strong>ℹ️ ¿Por qué apareció este mensaje?</strong><br><br>

<strong>Durante esta simulación, el perfil permaneció dentro de los límites sin descompresión mostrados.</strong>
En ningún momento el límite dinámico sin descompresión (NDL) representado por el sistema
alcanzó cero, ni se generaron paradas de descompresión obligatorias dentro del entorno simulado.
<br><br>

El mensaje mostrado <strong>no indica un error, una inmersión fallida ni una violación</strong>.
Es estrictamente informativo y se deriva del
<strong>mismo modelo fisiológico interno</strong> aplicado de forma consistente durante toda la simulación.
<br><br>

<strong>¿Cómo funciona este simulador?</strong><br>
Este simulador es una <strong>herramienta de visualización e ilustración</strong>
destinada a presentar conceptos generales relacionados con la fisiología del buceo.
Se basa en un <strong>modelo teórico de seguimiento continuo de tejidos</strong>,
inspirado en marcos de descompresión ampliamente documentados
(como Bühlmann ZHL-16C con lógica de factores de gradiente),
aplicado exclusivamente con fines representativos.
<br><br>

Durante la inmersión simulada, el sistema:
<ul style="margin:8px 0 0 18px;">
  <li>Representa estimaciones relativas de la absorción de gas inerte en compartimentos tisulares teóricos</li>
  <li>Muestra la proximidad de dichos compartimentos a límites modelados</li>
  <li>Ilustra cómo varía la conservatividad del ascenso <em>solo dentro de la simulación</em></li>
</ul>
<br>

<strong>¿Por qué puede aparecer un aviso si se respetó el NDL?</strong><br>
Incluso cuando no se representa una obligación de descompresión,
el modelo puede mostrar <strong>cargas relativamente elevadas de gas inerte</strong>
en determinados tejidos simulados.
Esto puede ocurrir en perfiles que incluyen:
<ul style="margin:8px 0 0 18px;">
  <li>Tiempos prolongados en el fondo</li>
  <li>Exposiciones cercanas al límite sin descompresión</li>
  <li>Profundidades moderadas mantenidas durante intervalos largos</li>
</ul>
<br>

En estos casos, el sistema puede presentar un
<strong>mensaje informativo preventivo</strong>,
cuyo único propósito es aportar contexto fisiológico adicional dentro de la visualización.
Este mensaje <strong>no constituye una instrucción operativa ni una recomendación de buceo</strong>.
<br><br>

<strong>🟠 Aclaración importante:</strong><br>
Este mensaje <strong>no representa requisitos de descompresión</strong>,
<strong>no es una alarma ni una instrucción de una computadora de buceo</strong>,
y <strong>no implica prácticas inseguras, incorrectas o no conformes</strong>.
Refleja únicamente que, dentro del modelo simulado,
ciertos tejidos presentaron una carga de gas inerte relativamente mayor
en comparación con una inmersión recreativa corta típica.
<br><br>

<strong>En términos simples:</strong><br>
El perfil simulado permaneció dentro de los límites representados.
Este mensaje simplemente indica:
<em>“Este escenario simulado se aproximó a un margen conservador, por lo que se muestra información adicional para contextualizar el perfil.”</em>
<br><br>

<strong>Aviso legal:</strong><br>
Este simulador se proporciona <strong>exclusivamente con fines de visualización e ilustración</strong>.
<strong>No es una computadora de buceo</strong>,
<strong>no sustituye la formación certificada ni el papel educativo de las agencias reconocidas</strong>,
y <strong>no debe utilizarse como base para la toma de decisiones en inmersiones reales</strong>.
`
  },

  // ===================================================
  // PRE-DIVE CHECK
  // ===================================================
  predive: {
    title: "Chequeo de seguridad previo a la inmersión",
    subtitle: "Chequeo previo estándar de la industria (BWRAF) y selección de gas",
    selectGas: "Selecciona el gas respirable",
    start: "Iniciar inmersión",
    cancel: "Cancelar y Reset",
    descargar: "Descargar reporte",
    bwraf: {
      b: "BCD: inflar / desinflar, inflador correcto",
      w: "Pesos: cantidad correcta, liberación rápida libre",
      r: "Anclajes: correas, hebillas y tanque asegurados",
      a: "Aire: válvula abierta, respirar y comprobar presión",
      f: "Final: máscara, aletas, computadora, compañero listo"
    }
  },


comparativa_tablas_tejidos_bhulmann: {
  text: `
    <div style="display:flex; flex-direction:column; gap:14px; line-height:1.65; color:#eaf4ff;">

      <div style="background:rgba(255,255,255,.06); border:1px solid rgba(255,255,255,.08); border-radius:16px; padding:16px;">
        <div style="font-size:18px; font-weight:700; margin-bottom:8px;">
          🧠📊 ¿Tablas o modelo fisiológico?
        </div>
        <div style="font-size:14px; opacity:.95;">
          Ambos sirven para estimar el tiempo de no descompresión, pero <strong>no funcionan igual</strong>.
          Por eso a veces pueden mostrar resultados diferentes.
        </div>
      </div>

      <div style="display:grid; gap:12px;">
        
        <div style="background:rgba(0,153,255,.10); border:1px solid rgba(0,153,255,.25); border-radius:16px; padding:16px;">
          <div style="font-size:16px; font-weight:700; margin-bottom:8px;">
            🔵 Tablas recreativas (PADI / DSAT)
          </div>
          <div style="font-size:14px;">
            <div>⏱️ Te dan un <strong>tiempo fijo</strong> según la profundidad.</div>
            <div>📚 Están basadas en estudios y en márgenes de seguridad.</div>
            <div>🧮 <strong>No calculan</strong> tu cuerpo en tiempo real.</div>
            <div>🟢 Son simples, rápidas y fáciles de entender.</div>
          </div>

          <div style="margin-top:10px; font-size:14px; background:rgba(255,255,255,.05); border-radius:12px; padding:10px;">
            👉 Ejemplo: a <strong>20 m</strong>, la tabla puede decir <strong>NDL ≈ 45 min</strong>.
          </div>
        </div>

        <div style="background:rgba(0,255,170,.08); border:1px solid rgba(0,255,170,.22); border-radius:16px; padding:16px;">
          <div style="font-size:16px; font-weight:700; margin-bottom:8px;">
            🟢 Modelo Bühlmann (este simulador)
          </div>
          <div style="font-size:14px;">
            <div>🧠 Simula <strong>16 tejidos virtuales</strong> del cuerpo.</div>
            <div>📈 Calcula en tiempo real cómo absorben y liberan nitrógeno.</div>
            <div>⚙️ Se adapta a tu perfil real: <strong>profundidad, tiempo y gas</strong>.</div>
            <div>🎯 Por eso es más dinámico y más realista.</div>
          </div>

          <div style="margin-top:10px; font-size:14px; background:rgba(255,255,255,.05); border-radius:12px; padding:10px;">
            👉 Aquí el <strong>NDL no es fijo</strong>: se calcula como el momento en que <strong>ya sería necesaria una parada</strong>.
          </div>
        </div>

      </div>

      <div style="background:rgba(255,196,0,.10); border:1px solid rgba(255,196,0,.25); border-radius:16px; padding:16px;">
        <div style="font-size:16px; font-weight:700; margin-bottom:8px;">
          ⚠️ ¿Por qué a veces no coinciden?
        </div>
        <div style="font-size:14px;">
          <div>📚 Las tablas recreativas son más <strong>conservadoras</strong>.</div>
          <div>🧠 El modelo Bühlmann calcula lo que está ocurriendo en el cuerpo de forma continua.</div>
          <div>🔍 Por eso el simulador puede mostrar un NDL diferente al de una tabla clásica.</div>
        </div>
      </div>

      <div style="background:rgba(255,255,255,.06); border:1px solid rgba(255,255,255,.08); border-radius:16px; padding:16px;">
        <div style="font-size:16px; font-weight:700; margin-bottom:8px;">
          💡 En resumen
        </div>
        <div style="font-size:14px;">
          <div>🔵 <strong>Tablas</strong> = una aproximación simple y conservadora</div>
          <div>🟢 <strong>Bühlmann</strong> = una simulación fisiológica más realista</div>
        </div>

        <div style="margin-top:10px; font-size:14px; font-weight:600;">
          👉 Este simulador usa el modelo Bühlmann para ofrecer una estimación más dinámica del NDL.
        </div>
      </div>

    </div>
  `
},


block_student: {
    riesgo_accidente_disbarico: "Alto riesgo de accidente disbárico",
    riesgo_microburbujas: "Riesgo de microburbujas",
    reducir_velocidad: "Debes reducir la velicidad de ascenso a 9m/min",
    riesgo_accidente_disbarico: "Alto riesgo de accidente disbárico",
    ascenso_ideal: "Velocidad Ideal",
    ascenso_lento: "Ascenso Lento. Correcto",
    velocidad_asenso: "Velocidad de ascenso"


},


dashboard:{
  
    profile_txt: "Mi perfil",
    logout_txt:"Cerrar sesión",
    welcome_label:"Bienvenido",
    payments_title:"Panel de pagos",
    startSimulatorBtn:"🎮 Iniciar simulador de buceo",
    view_payments:"Ver Pagos",
    view_simulator_logs:"Logs del Simulador",
    paymentsEmpty:"Cargando pagos...",
    response_title:"Pagos",
    activo_con_previa_cancelacion: "🎮 Acceso activo (cancelación programada)",
    fecha_cancelacion_suscripcion: "⚠️ Tu suscripción se cancelará el:",
    en_proceso_cancelacion: "🟠 Suscripción en proceso de cancelación",
    acceso_hasta: "Acceso disponible hasta:",
    despues_esta_fecha_no_acceso: "Después de esta fecha se perderá el acceso automáticamente",
    suscripcion_finalizada: "💳 Suscripción finalizada",
    suscripcion_cancelada: "🔴 Suscripción cancelada",
    acceso_habiliatdo: "🟢 Acceso habilitado:",
    upgrade_plan : "Modificar mi plan",
    modificar_a :"Modificar a:",
    tienes_el_plan_maximo: "✨ Tienes el plan máximo disponible.",
    reactivar_suscripcion: "🔄 Reactivar suscripción",
    cancelar_suscripcion: "❌ Cancelar suscripción",
    en_proceso: "⏳ Procesando...",
    cancelando: "⏳ Cancelando...",
    cancelada: "✅ Cancelada",
    error: "❌ Error",
    reactivando_suscripcion: "⏳ Reactivando...",
    reactivada: "✅ Reactivada",
    no_pagos_aun: "No hay pagos registrados aún.",
    pagar: "💳 Pagar",
    pagado: "💳 Acreditado",
    activar_acceso_simulador: "💳 Activar acceso al simulador",
    sin_suscripcion_inactiva: "🔴 Sin suscripción activa",
    membresia_title: "Membresía",
    credits_title: "Creditos",
    add_saldo: "Agregar Créditos"

}










}